import { createBrowserRouter } from "react-router";
import { loginRoute, RequireAuth, verificationReturnRoute } from "@/features/auth";
import { cabinetRoutes } from "@/features/cabinet";
import { cartRoutes } from "@/features/cart";
import { catalogRoutes } from "@/features/catalog";
import { checkoutRoutes } from "@/features/checkout";
import { favoritesRoutes } from "@/features/favorites";
import { ComingSoonPage, legalRoutes, ShopLayout } from "@/features/layout";
import { NotFoundPage } from "./NotFoundPage";
import { RouteErrorPage } from "./RouteErrorPage";

/** Pages linked from the header that arrive in later phases. */
const LATER = ["promo", "delivery", "stores"];

/**
 * All routes of the app. Features export their route objects; the app only composes them.
 * Storefront and cabinet share the site shell (desktop header and footer, the mobile tab bar); login is bare.
 * Each route's `handle.shell` tells the mobile shell its tab and chrome (features/layout/model/shell.ts).
 */
export const router = createBrowserRouter([
  { ...loginRoute, errorElement: <RouteErrorPage /> },
  // dev-only component gallery; `import.meta.env.DEV` is false in builds, so the page is not bundled
  ...(import.meta.env.DEV
    ? [{ path: "/_kit", lazy: async () => ({ Component: (await import("./KitPage")).KitPage }) }]
    : []),
  {
    path: "/",
    element: <ShopLayout />,
    errorElement: <RouteErrorPage />,
    children: [
      {
        // a failing page keeps the header and footer around it
        errorElement: <RouteErrorPage />,
        children: [
          ...catalogRoutes,
          ...cartRoutes,
          ...favoritesRoutes,
          ...legalRoutes,
          ...LATER.map((path) => ({ path, element: <ComingSoonPage /> })),
          // the cabinet hub is public (guests see «Войти», language, support); its sections guard themselves
          cabinetRoutes,
          // back from MyID's page (ADR-0013); it handles a missing session itself, so the code never reaches /login
          verificationReturnRoute,
          { element: <RequireAuth />, children: [checkoutRoutes] },
          { path: "*", element: <NotFoundPage /> },
        ],
      },
    ],
  },
]);
